export enum Relation {
    PARENT = 'PARENT',
    CHILD = 'CHILD',
    SPOUSE = 'SPOUSE',
    SIBLING = 'SIBLING'
}

export interface Nominee {
    id: string;
    userId: string;
    relation: Relation;
    name: string;
    emailId: string;
    phoneNumber: string;
    address: string;
    nomineeGuardian: NomineeGuardian;
}

export interface NomineeGuardian {
    name: string;
    emailId: string;
    phoneNumber: string;
    address: string;
}
